var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 258,
    viewBox: "0 0 135 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71496 94.412L0 68.9561C0 45.7562 6.36316 24.5949 12.2134 19.1528C35 -2.04396 86 -8.0441 122.257 19.5844C130.08 25.5456 135 54.9558 135 68.9561L131.37 94.4798C130.137 93.4907 128.672 92.7624 126.948 92.349C126.983 91.0012 127 89.6388 127 88.2623C127 41.8799 107.169 16.9561 67 16.9561C26.8312 16.9561 7 41.8799 7 88.2623C7 89.6388 7.01747 91.0012 7.05241 92.349C5.36742 92.7529 3.93022 93.4574 2.71496 94.412Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.189 26.7714C81.5 36.4561 50.8111 35.8238 34.3868 26.7714C27.6355 23.0504 41.2727 9.95605 67.1012 9.95605C82.205 9.95606 106.247 21.1799 97.189 26.7714Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6089 12.5361C46.8563 25.9864 23.8365 38.691 8.02002 39.4343C1.51864 39.7398 6.38114 24.7986 25.5416 13.7363C36.7462 7.26738 59.085 4.77055 54.6089 12.5361Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.682 39.3194C108.157 39.3305 85.6451 25.7471 77.0931 12.4213C73.5779 6.94368 88.9485 3.68415 108.109 14.7465C119.314 21.2154 132.645 39.313 123.682 39.3194Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9999 161.354V178.827C71.9347 214.312 72.1606 243.897 93.0257 257.403C93.9342 257.991 95.1659 257.648 95.7335 256.726C99.5125 250.592 102.939 245.011 106.017 239.917C106.952 241.441 107.941 243.044 108.985 244.73C109.554 245.648 110.776 245.981 111.662 245.363C120.005 239.549 122.284 229.351 119.173 216.95C124.78 206.123 127.244 198.689 126.677 192.785C127.382 160.673 127.162 141.475 123.664 129.998C123.582 129.999 123.499 130 123.415 130C122.257 130 121.123 129.89 120.024 129.679C113.832 145.01 103.507 156.015 88.9999 161.354Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairU);
export default __webpack_public_path__ + "static/media/Hair U.c6b3cf50b50ce2ead82d3d95cc671b52.svg";
export { ForwardRef as ReactComponent };